import { render, staticRenderFns } from "./MyQuiz.vue?vue&type=template&id=78c5830e&scoped=true&"
import script from "./MyQuiz.vue?vue&type=script&lang=js&"
export * from "./MyQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MyQuiz.vue?vue&type=style&index=0&id=78c5830e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5830e",
  null
  
)

export default component.exports